/**
 * Currency utility class similar to C# Currency class in Paybyrd.SharedLibs.ValueObjects
 * Provides methods for handling currency codes, conversion between decimal and ISO amounts,
 * and formatting based on currency-specific exponents
 */

/**
 * Currency data in format [three-letter code, numeric code, exponent]
 * Exponent represents the number of decimal places for the currency
 */
const CURRENCY_DATA = [
  ["AED", 784, 2],
  ["AFN", 971, 2],
  ["ALL", 8, 2],
  ["AMD", 51, 2],
  ["ANG", 532, 2],
  ["AOA", 973, 2],
  ["ARS", 32, 2],
  ["AUD", 36, 2],
  ["AWG", 533, 2],
  ["AZN", 944, 2],
  ["BAM", 977, 2],
  ["BBD", 52, 2],
  ["BDT", 50, 2],
  ["BGN", 975, 2],
  ["BHD", 48, 3],
  ["BIF", 108, 0],
  ["BMD", 60, 2],
  ["BND", 96, 2],
  ["BOB", 68, 2],
  ["BOV", 984, 2],
  ["BRL", 986, 2],
  ["BSD", 44, 2],
  ["BTN", 64, 2],
  ["BWP", 72, 2],
  ["BYR", 974, 0],
  ["BZD", 84, 2],
  ["CAD", 124, 2],
  ["CDF", 976, 2],
  ["CHE", 947, 2],
  ["CHF", 756, 2],
  ["CHW", 948, 2],
  ["CLF", 990, 0],
  ["CLP", 152, 0],
  ["CNY", 156, 2],
  ["COP", 170, 2],
  ["COU", 970, 2],
  ["CRC", 188, 2],
  ["CUC", 931, 2],
  ["CUP", 192, 2],
  ["CVE", 132, 0],
  ["CZK", 203, 2],
  ["DJF", 262, 0],
  ["DKK", 208, 2],
  ["DOP", 214, 2],
  ["DZD", 12, 2],
  ["EGP", 818, 2],
  ["ERN", 232, 2],
  ["ETB", 230, 2],
  ["EUR", 978, 2],
  ["FJD", 242, 2],
  ["FKP", 238, 2],
  ["GBP", 826, 2],
  ["GEL", 981, 2],
  ["GHS", 936, 2],
  ["GIP", 292, 2],
  ["GMD", 270, 2],
  ["GNF", 324, 0],
  ["GTQ", 320, 2],
  ["GYD", 328, 2],
  ["HKD", 344, 2],
  ["HNL", 340, 2],
  ["HRK", 191, 2],
  ["HTG", 332, 2],
  ["HUF", 348, 2],
  ["IDR", 360, 2],
  ["ILS", 376, 2],
  ["INR", 356, 2],
  ["IQD", 368, 3],
  ["IRR", 364, 0],
  ["ISK", 352, 0],
  ["JMD", 388, 2],
  ["JOD", 400, 3],
  ["JPY", 392, 0],
  ["KES", 404, 2],
  ["KGS", 417, 2],
  ["KHR", 116, 2],
  ["KMF", 174, 0],
  ["KPW", 408, 0],
  ["KRW", 410, 0],
  ["KWD", 414, 3],
  ["KYD", 136, 2],
  ["KZT", 398, 2],
  ["LAK", 418, 0],
  ["LBP", 422, 0],
  ["LKR", 144, 2],
  ["LRD", 430, 2],
  ["LSL", 426, 2],
  ["LTL", 440, 2],
  ["LVL", 428, 2],
  ["LYD", 434, 3],
  ["MAD", 504, 2],
  ["MDL", 498, 2],
  ["MGA", 969, 2],
  ["MKD", 807, 0],
  ["MMK", 104, 0],
  ["MNT", 496, 2],
  ["MOP", 446, 2],
  ["MRO", 478, 2],
  ["MUR", 480, 2],
  ["MVR", 462, 2],
  ["MWK", 454, 2],
  ["MXN", 484, 2],
  ["MXV", 979, 2],
  ["MYR", 458, 2],
  ["MZN", 943, 2],
  ["NAD", 516, 2],
  ["NGN", 566, 2],
  ["NIO", 558, 2],
  ["NOK", 578, 2],
  ["NPR", 524, 2],
  ["NZD", 554, 2],
  ["OMR", 512, 3],
  ["PAB", 590, 2],
  ["PEN", 604, 2],
  ["PGK", 598, 2],
  ["PHP", 608, 2],
  ["PKR", 586, 2],
  ["PLN", 985, 2],
  ["PYG", 600, 0],
  ["QAR", 634, 2],
  ["RON", 946, 2],
  ["RSD", 941, 2],
  ["RUB", 643, 2],
  ["RWF", 646, 0],
  ["SAR", 682, 2],
  ["SBD", 90, 2],
  ["SCR", 690, 2],
  ["SDG", 938, 2],
  ["SEK", 752, 2],
  ["SGD", 702, 2],
  ["SHP", 654, 2],
  ["SLL", 694, 0],
  ["SOS", 706, 2],
  ["SRD", 968, 2],
  ["SSP", 728, 2],
  ["STD", 678, 0],
  ["SVC", 222, 2],
  ["SYP", 760, 2],
  ["SZL", 748, 2],
  ["THB", 764, 2],
  ["TJS", 972, 2],
  ["TMT", 934, 2],
  ["TND", 788, 3],
  ["TOP", 776, 2],
  ["TRY", 949, 2],
  ["TTD", 780, 2],
  ["TWD", 901, 2],
  ["TZS", 834, 2],
  ["UAH", 980, 2],
  ["UGX", 800, 2],
  ["USD", 840, 2],
  ["USN", 997, 2],
  ["USS", 998, 2],
  ["UYI", 940, 0],
  ["UYU", 858, 2],
  ["UZS", 860, 2],
  ["VEF", 937, 2],
  ["VND", 704, 0],
  ["VUV", 548, 0],
  ["WST", 882, 2],
  ["XAF", 950, 0],
  ["XCD", 951, 2],
  ["XOF", 952, 0],
  ["XPF", 953, 0],
  ["YER", 886, 2],
  ["ZAR", 710, 2],
  ["ZMW", 967, 2],
  ["ZWL", 932, 2]
];

// Create lookup dictionaries for faster access
const DATA_BY_THREE_LETTER_CODE = CURRENCY_DATA.reduce((acc, [code, numeric, exponent]) => {
  acc[code] = { numericCode: numeric, exponent };
  return acc;
}, {});

const DATA_BY_NUMERIC_CODE = CURRENCY_DATA.reduce((acc, [code, numeric, exponent]) => {
  acc[numeric] = { threeLetterCode: code, exponent };
  return acc;
}, {});

/**
 * Currency class for handling currency operations and conversions
 */
class Currency {
  /**
   * Creates a new Currency instance
   * @param {string} threeLetterCode - ISO 4217 three-letter currency code
   * @param {number} numericCode - ISO 4217 numeric currency code
   * @param {number} exponent - Number of decimal places for the currency
   */
  constructor(threeLetterCode, numericCode, exponent) {
    this.threeLetterCode = threeLetterCode;
    this.numericCode = numericCode;
    this.exponent = exponent;
  }

  /**
   * Gets a Currency instance by its three-letter code
   * @param {string} threeLetterCode - Three-letter currency code (e.g., 'USD')
   * @returns {Object} Result object with currency (if found) or error
   */
  static get(threeLetterCode) {
    if (!threeLetterCode || typeof threeLetterCode !== 'string') {
      return {
        currency: null,
        error: { message: 'Currency code cannot be null or empty' }
      };
    }

    const currencyCode = threeLetterCode.trim().toUpperCase();
    const data = DATA_BY_THREE_LETTER_CODE[currencyCode];

    if (!data) {
      return {
        currency: null,
        error: { message: `Currency with alpha-3 code: '${currencyCode}' not found` }
      };
    }

    return {
      currency: new Currency(currencyCode, data.numericCode, data.exponent),
      error: null
    };
  }

  /**
   * Gets a Currency instance by its numeric code
   * @param {number} numericCode - Numeric currency code
   * @returns {Object} Result object with currency (if found) or error
   */
  static getByNumericCode(numericCode) {
    if (typeof numericCode !== 'number') {
      return {
        currency: null,
        error: { message: 'Numeric code must be a number' }
      };
    }

    const data = DATA_BY_NUMERIC_CODE[numericCode];

    if (!data) {
      return {
        currency: null,
        error: { message: `Currency with numeric code: '${numericCode}' not found` }
      };
    }

    return {
      currency: new Currency(data.threeLetterCode, numericCode, data.exponent),
      error: null
    };
  }

  /**
   * Gets a Currency instance by its three-letter code, throwing an error if not found
   * @param {string} threeLetterCode - Three-letter currency code
   * @returns {Currency} Currency instance
   * @throws {Error} If currency is not found
   */
  static getUnsafe(threeLetterCode) {
    const { currency, error } = this.get(threeLetterCode);
    
    if (error) {
      throw new Error(error.message);
    }
    
    return currency;
  }

  /**
   * Gets a Currency instance by its numeric code, throwing an error if not found
   * @param {number} numericCode - Numeric currency code
   * @returns {Currency} Currency instance
   * @throws {Error} If currency is not found
   */
  static getUnsafeByNumericCode(numericCode) {
    const { currency, error } = this.getByNumericCode(numericCode);
    
    if (error) {
      throw new Error(error.message);
    }
    
    return currency;
  }

  /**
   * Tries to create a Currency instance from a three-letter code
   * @param {string} threeLetterCode - Three-letter currency code
   * @returns {Object} Object with success flag and currency if successful
   */
  static tryCreate(threeLetterCode) {
    const { currency, error } = this.get(threeLetterCode);
    
    return {
      success: !error,
      currency
    };
  }

  /**
   * Gets a list of all valid currencies
   * @returns {Array<Currency>} Array of all valid Currency instances
   */
  static getValidList() {
    return CURRENCY_DATA.map(([code, numeric, exponent]) => 
      new Currency(code, numeric, exponent)
    );
  }

  /**
   * Converts an amount from decimal representation to ISO (smallest currency unit)
   * @param {number} amount - Decimal amount (e.g., 10.99)
   * @returns {number} ISO amount (e.g., 1099 for USD)
   */
  toIsoAmount(amount) {
    if (typeof amount !== 'number') {
      throw new Error('Amount must be a number');
    }
    
    // Use Math.round to handle floating point precision issues
    return Math.round(amount * Math.pow(10, this.exponent));
  }

  /**
   * Converts an amount from ISO (smallest currency unit) to decimal representation
   * @param {number} isoAmount - ISO amount (e.g., 1099 for USD)
   * @returns {number} Decimal amount (e.g., 10.99)
   */
  fromIsoAmount(isoAmount) {
    if (typeof isoAmount !== 'number') {
      throw new Error('ISO amount must be a number');
    }
    
    return isoAmount / Math.pow(10, this.exponent);
  }

  /**
   * Formats an amount according to the currency's exponent
   * @param {number} amount - Decimal amount to format
   * @param {Object} options - Formatting options
   * @param {string} options.locale - Locale to use for formatting (defaults to 'en-US')
   * @param {boolean} options.symbol - Whether to include currency symbol (defaults to true)
   * @returns {string} Formatted currency amount
   */
  format(amount, { locale = 'en-US', symbol = true } = {}) {
    const formatOptions = {
      style: symbol ? 'currency' : 'decimal',
      currency: this.threeLetterCode,
      minimumFractionDigits: this.exponent,
      maximumFractionDigits: this.exponent
    };
    
    return new Intl.NumberFormat(locale, formatOptions).format(amount);
  }

  /**
   * Validates if an amount has the correct number of decimal places for this currency
   * @param {number|string} amount - Amount to validate
   * @returns {boolean} Whether the amount has valid precision for this currency
   */
  hasValidPrecision(amount) {
    const strAmount = amount.toString();
    const decimalParts = strAmount.split('.');
    
    // If no decimal point, valid for any currency
    if (decimalParts.length === 1) return true;
    
    // If decimal point exists, validate against exponent
    const decimalDigits = decimalParts[1].length;
    return decimalDigits <= this.exponent;
  }

  /**
   * Gets the regular expression for validating input of this currency
   * @returns {RegExp} Regular expression that matches valid input for this currency
   */
  getInputRegex() {
    if (this.exponent === 0) {
      return /^\d*$/; // Only integers
    }
    return new RegExp(`^\\d*\\.?\\d{0,${this.exponent}}$`);
  }

  /**
   * Checks if this currency equals another currency
   * @param {Currency} other - Another currency to compare
   * @returns {boolean} Whether the currencies are equal (based on numeric code)
   */
  equals(other) {
    return other && this.numericCode === other.numericCode;
  }
}

export default Currency;